import { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export interface PageContainerProps {
  children: ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  padding?: "none" | "sm" | "md" | "lg";
  withBackground?: boolean;
  className?: string;
}

const maxWidthClasses = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  "2xl": "max-w-screen-2xl",
  full: "max-w-full",
};

const paddingClasses = {
  none: "",
  sm: "px-4 py-4",
  md: "px-6 py-8",
  lg: "px-8 py-12",
};

export function PageContainer({
  children,
  maxWidth = "2xl",
  padding = "md",
  withBackground = true,
  className = "",
}: PageContainerProps) {
  return (
    <div className="flex flex-col min-h-screen [body[data-environment-banner]_&]:min-h-[calc(100vh-1.75rem)]">
      {withBackground && (
        <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50" />
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-navigator-secondary/20 rounded-full blur-3xl animate-blob" />
          <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-navigator-accent/20 rounded-full blur-3xl animate-blob animation-delay-2000" />
        </div>
      )}

      <div className="flex-1 w-full">
        <div
          className={cn(maxWidthClasses[maxWidth], paddingClasses[padding], "mx-auto", className)}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
